import { ReturnTrackingTriggerKey } from "@redotech/redo-flows-common/triggers";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getAttentiveIntegration = {
  name: "getAttentiveIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    integration: z
      .object({
        _id: zExt.objectId(),
        team: zExt.objectId(),
        attentiveCompanyId: z.string(),
        attentiveCompanyName: z.string().optional(),
        accessToken: z.string(),
        events: z.array(z.string()),
        purposes: z.array(z.string()),
        // Optional so a new client validating an old server's response during
        // the deploy window doesn't fail the whole integrations page.
        returnTrackingTriggers: z
          .array(createEnum(ReturnTrackingTriggerKey))
          .optional(),
      })
      .optional(),
  }),
};
